import React from "react";
import commandPaletteStore from "Stores/CommandPaletteStore";

// Platform is fixed for the session, so detect once at module scope.
const isMac =
  typeof navigator !== "undefined" &&
  /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent || "");
const shortcutLabel = isMac ? "⌘K" : "Ctrl K";

/**
 * Header pill that opens the command palette. Click or focus opens the popup;
 * actual typing happens inside the popup's input (which auto-focuses).
 */
const CommandPaletteSearchInput = () => {
  const handleOpen = () => commandPaletteStore.open();
  const handleKeyDown = e => {
    if (e.key === "Enter" || e.key === " " || e.key === "ArrowDown") {
      e.preventDefault();
      handleOpen();
    }
  };
  return (
    <button
      type="button"
      className="commandPaletteSearchTrigger"
      onClick={handleOpen}
      onKeyDown={handleKeyDown}
      aria-label="Open quick search"
    >
      <i className="material-icons-outlined triggerIcon">search</i>
      <span className="triggerLabel">Search or ask AI…</span>
      <span className="triggerShortcut">{shortcutLabel}</span>
    </button>
  );
};

export default CommandPaletteSearchInput;
